import React from "react";
import "./About.css";

/**
 * Uses Tailwind CSS for styling
 * Tailwind file is imported in App.css
 */

export default function About() {
  return (
    <div className="larger-font app min-h-screen text-blue-200 flex flex-col p-20">

<div style={{ display: "flex", justifyContent: "center" }}>
     <a href="/">
  <img
    src="/saturn1.png"
    url="/"
    alt="Saturn"
    style={{
      width: "280px",
      height: "auto",
      cursor: "pointer"
    }}
  />
  </a>
</div>


     <div className="about-text">
      Hi, my name is James Abraham. I'm an amateur physicist and philosopher. On this website I'd like to share some of my work.
      </div>
      <div className="about-text">
              I'm proud to say that I am the creator of the Background Bank interpretation of quantum mechanics and the Theory of Polytypes in philosophy of mind. These are separate theories in different fields, unconnected with each other.
        </div>
         
        <div className="about-text">
                I have tried really hard over the years to understand some aspects of the world. On this website you'll find my best efforts. Sometimes it was a hobby; sometimes it was a quest. Right now it is a liability since it doesn't help keep me in curries, beer, or flat whites. But as human beings, lost in this strange place, what could be more exciting than understanding a fundamental principle? Those times when there is enough food in your belly. When you have a drink at hand. When it is a clear night sky. When it is not too hot, not too cold, and you sit around a fire with your conversation partners, your fellow travellers. And you look up at the stars. "What does it all mean?" This is what it is all about for me. That's what kept me going. </div> 
{/* <div>
  Throughout this time I have had to deal with the most tremendous prejudice in our society against amateur researchers. There is an unjustified presumption that giving any space to people without the correct sheepskin, would be like opening the gates and allowing barbarians to run untrammeled. There is such an ignoble, status-preserving motive at the root of this behaviour, which uses faux concerns of the greater good of science, as a pretext. 
</div> */}
{/* <div className="about-text">  
The reality is that for more than half of the history of science, since Galileo, more than half of the most important researchers were amateurs. It is true that in the last century, many scientific fields reached such a degree of technical sophistication, that it was rare for amateurs to make contributions.</div> */}


  <br/>
    </div>
  );
}

